/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type { FileMatchRequest } from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ApiFileMatchRequestController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-file-match-request-controller
   * @name CreateMatchRequest
   * @request POST:/api/v1/fileMatchRequest
   */
  createMatchRequest = (data: FileMatchRequest, params: RequestParams = {}) =>
    this.http.request<object, any>({
      path: `/v1/fileMatchRequest`,
      method: 'POST',
      body: data,
      type: ContentType.FormData,
      format: 'json',
      ...params,
    })

  static createMatchRequestPath = '/v1/fileMatchRequest'
  static createMatchRequestMethod = 'POST'
}
